import { HotProbsMarketsOutcomesMapItem } from 'astra-core/containers/CommonDataProvider'
import React, { FC } from 'react'
import { Event } from 'betweb-openapi-axios'

import { EventRowCoefficient } from '../EventRowCoefficient'

export const CoefficientsList: FC<{
  outcomeTypes?: HotProbsMarketsOutcomesMapItem[]
  event: Event
}> = ({ outcomeTypes, event }) => {
  return (
    <>
      {outcomeTypes?.map((coefficientData) => (
        <EventRowCoefficient
          {...coefficientData}
          event={event}
          key={coefficientData.outcomeTypesName[0]}
        />
      ))}
    </>
  )
}
